import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {MapInfoWindow, MapMarker} from "@angular/google-maps";
import {arrayIsSet} from "../../../providers/service/global-variables.service";
import {BehaviorSubject, Observable, Subject} from "rxjs";


export type ButtonMarkerType = { action: any, iconLocal?: string, iconMaterial?: string, color?: 'accent' | 'primary' | 'warn' }
export type MarkerType = {
    name?: string,
    label?: google.maps.MarkerLabel,
    location: google.maps.LatLng,
    infoWindow?: {
        buttons: ButtonMarkerType[]
    },
    icon?: string | google.maps.Icon | google.maps.Symbol
}
export const typeZoomValue = {
    fitBound: 'FITBOUND',

}
export type TypeZoomType = typeof typeZoomValue[keyof typeof typeZoomValue]


@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    standalone: false
})
export class MapComponent implements OnInit, OnChanges {
    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow | undefined;
    options: google.maps.MapOptions = {
        center: {lat: 40, lng: -20},
        zoom: 4
    };
    private map: google.maps.Map | undefined
    @Input() markers: MarkerType[] | undefined;
    @Input() typeZoom: { type: TypeZoomType } | undefined | null;
    @Input() zoomToCenter: { location: google.maps.LatLng  } | undefined | null;
    @Output() clickButton = new EventEmitter<{ action: any }>()
    @Output() mapReady = new EventEmitter<google.maps.Map>()
    markerEmit = new Subject<MarkerType>();
    mapChangeTypeIdEmit = new Subject<string>();
    marker$: Observable<MarkerType> = this.markerEmit.asObservable();
    mapChangeTypeId$: Observable<string> = this.mapChangeTypeIdEmit.asObservable();

    constructor() {
    }

    ngOnInit(): void {
        // console.log(this.markers)
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.typeZoom != null) {
            this.changeZoom();
        }

    }

    openInfoWindow(markerInfo: MapMarker, marker: MarkerType) {
        this.infoWindow?.open(markerInfo);
        this.markerEmit.next(marker);
    }

    // closeInfoWindow(markerInfo: MapMarker, marker: MarkerType) {
    //     this.infoWindow?.close();
    //     this.markerEmit.next(undefined);
    // }

    clickInfoWindowButton(action: string) {
        this.clickButton.next({action})
    }

    mapIsReady(event: google.maps.Map) {
        this.map = event;
        this.mapReady.next(event);
    }

    fitBounds() {
        if (arrayIsSet(this.markers) && this.map != null) {
            let bounds = new google.maps.LatLngBounds();
            this.markers.forEach(marker => {
                const bound = new google.maps.LatLng(marker.location)
                bounds.extend(bound);
            })
            this.map?.fitBounds(bounds)
        }
    }

    changeZoom() {
        if (this.typeZoom?.type === typeZoomValue.fitBound) {
            this.fitBounds();
        }
    }

    closeMarkerEmit = new BehaviorSubject(true);
    closeMarker$ = this.closeMarkerEmit.asObservable();

    changeType() {
        this.mapChangeTypeIdEmit.next(this.map?.getMapTypeId())
        this.closeMarkerEmit.next(false)
        const color = this.map?.getMapTypeId() == 'roadmap' ? '#000000' : '#FFFFFF';
        this.markers?.forEach(m => {
            if (m.label != null) {
                m.label.color = color;
            }
        })
        setTimeout(() => {
            this.closeMarkerEmit.next(true)
        }, 0)
    }

}
